import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEllipse = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 6 6"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <circle cx={3} cy={3} r={3} fill="currentColor" />
    </svg>
  );
};
export default SvgEllipse;
